import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-250b38a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-base curriculum-popup-container py-3" }
const _hoisted_2 = {
  key: 0,
  class: "curriculum-mark-down-container"
}
const _hoisted_3 = { class: "curriculum-mark-down" }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]

import { computed, PropType } from 'vue'
import { useI18n } from 'vue-i18n'
import { HelpAction, SolveAction } from '../../types/enums/help.enum'
import { useRoomStore } from '@/stores'


export default /*#__PURE__*/_defineComponent({
  __name: 'HelpRequestPopup',
  props: {
  helpRequaseType: {
    type: String as PropType<HelpAction>,
    default: undefined,
  },
  helpSolvedBy: {
    type: String as PropType<SolveAction>,
    default: undefined,
  },
  isMainEngine: {
    type: Boolean,
    default: false,
  },
  isCoachRole: {
    type: Boolean,
    default: false,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
},
  emits: ['on-close', 'confirm-solution'],
  setup(__props, { emit: __emit }) {

const emit = __emit
const props = __props
const i18n = useI18n()
const roomStore = useRoomStore()
const isRequestOriginalMaterial = computed(
  () => props.helpSolvedBy === SolveAction.OPEN_ORIGINAL_MATERIAL,
)
const message = computed(() => {
  switch (props.helpSolvedBy) {
    case SolveAction.SHARE_SCREEN:
      return props.isCoachRole
        ? i18n.t('help-popup.coach-message.share-screen')
        : i18n.t('help-popup.student-message.share-screen')
    case SolveAction.MOVE_ROOM:
      if (roomStore.isNightTime) {
        return props.isCoachRole
          ? i18n.t('help-popup.coach-message.move-room', {
              room: props.isMainEngine ? i18n.t('second-room') : i18n.t('main-room'),
            })
          : i18n.t('help-popup.student-message.move-room')
      } else {
        return props.isCoachRole
          ? i18n.t('help-popup.coach-message.move-room-operation-time', {
              room: props.isMainEngine ? i18n.t('second-room') : i18n.t('main-room'),
            })
          : i18n.t('help-popup.student-message.move-room-operation-time')
      }
    case SolveAction.RELOAD_ROOM:
      return props.isCoachRole
        ? i18n.t('help-popup.coach-message.reload-room')
        : i18n.t('help-popup.student-message.reload-room')
    case SolveAction.MUTE_CAMERA:
      return props.isCoachRole
        ? i18n.t('help-popup.coach-message.mute-camera')
        : i18n.t('help-popup.student-message.mute-camera')
    case SolveAction.OPEN_ORIGINAL_MATERIAL:
      return i18n.t('help-popup.coach-message.open-original-material')
    default:
      return ''
  }
})

const close = () => {
  emit('on-close', false)
}
const confirmSolved = () => {
  emit('confirm-solution')
}

return (_ctx: any,_cache: any) => {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_Popup = _resolveComponent("Popup")!

  return (_openBlock(), _createBlock(_component_Popup, {
    title: _unref(i18n).t('help-popup.notify'),
    open: !!__props.helpSolvedBy,
    onClose: close
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          type: "button",
          disabled: __props.isLoading,
          class: "btn btn-tertiary text-white text-base w-full",
          onClick: close
        }, _toDisplayString(_ctx.$t('help-popup.cancel-btn')), 9, _hoisted_5),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary text-white text-base w-full ml-2",
          disabled: __props.isLoading,
          onClick: confirmSolved
        }, _toDisplayString(_ctx.$t('help-popup.confirm-btn')), 9, _hoisted_6)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_Loading, {
        class: "curriculum-popup-container",
        "background-color": "#ffffffac",
        "is-fullscreen": "",
        "is-loading": __props.isLoading,
        size: "36"
      }, null, 8, ["is-loading"]),
      _createElementVNode("span", _hoisted_1, _toDisplayString(message.value), 1),
      (isRequestOriginalMaterial.value)
        ? (_openBlock(), _createElementBlock("blockquote", _hoisted_2, [
            _createElementVNode("ol", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(i18n).tm('help-popup.coach-message.original-material-markdown'), (msg, i) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: `og-${i}`,
                  class: "text-sm mb-2"
                }, _toDisplayString(msg), 1))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title", "open"]))
}
}

})